import axios from "../../axios";

export const getAvailableBalance = async (accountId, startDate = '', endDate = '') => {
  try {
    const response = await axios.get(
      `/api/v3/analysis/closingBalance?accountId=${accountId}&startDate=${startDate}&endDate=${endDate}`
    );
    return response.data;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};